'use strict';

angular.module('integrationModule')

.config(function ($stateProvider, resourceStateProvider)
{

    resourceStateProvider
    .state('admin.integrations', {
        url: 'integrations',
        model: 'Integration',
        viewOptions: 'integrationViewOptions',
        title: 'Integrations',
        edit: {
            templateUrl: 'integration/integration.edit.html',
            controller: 'IntegrationEditCtrl'
        },
        move: false
    });

});
